module.exports = __webpack_public_path__ + "img/pharmeyes_img.c6dea3d3.png";